// Pages temporarily closed to users: hidden behind a disabled UI and redirected at the router.
export const DISABLED_PAGE_PATHS = new Set(["/manav", "/veri-girisi", "/zrapor"]);

export const isPageDisabled = (path) => DISABLED_PAGE_PATHS.has(path);
